import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NotExist from '../pages/error/NotExist';
import RouteKey from './key';
import PrivateRoute from '../modules/profile/components/PrivateRoute';
import { OrganisationAccess, Role } from '../models';
import CoordinatorResitTransactionDetail from '../pages/resit/CoordinatorResitTransactionDetail';
import CoordinatorResitEmailSuccessPage from '../pages/resit/CoordinatorResitEmailSuccessPage';
import PrivateOrganisationRoute from '../modules/profile/components/PrivateOrganisationRoute';

const { coordinatorResitTransaction, coordinatorSendEmailSuccess } =
  RouteKey['resit-registration'].child;

/**
 * Handles link from email that navigates to resit related receipt, registration summary, success page etc.
 * @constructor
 */
const ResitRegistrationRoute = () => {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

  const RESIT_TITLE = t('resit->>ResitRegistrationRoute.Register Year-End MTL Exam');

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <NotExist />
      </Route>

      {/* coordinator resit */}
      <PrivateRoute
        path={`${path}/${coordinatorResitTransaction.route}`}
        roles={[Role.coordinator]}
      >
        <CoordinatorResitTransactionDetail title={RESIT_TITLE} isHideExamLevel />
      </PrivateRoute>

      <PrivateRoute
        path={`${path}/${coordinatorSendEmailSuccess.route}`}
        roles={[Role.coordinator]}
      >
        <PrivateOrganisationRoute
          path={`${path}/${coordinatorSendEmailSuccess.route}`}
          organisationAccess={[OrganisationAccess.resit]}
        >
          <CoordinatorResitEmailSuccessPage />
        </PrivateOrganisationRoute>
      </PrivateRoute>

      <Route path="*" exact>
        <Redirect to={`${path}`} />
      </Route>
    </Switch>
  );
};

export default ResitRegistrationRoute;
